<app-headers *ngIf="showHeader"></app-headers>
<app-toast-outlet></app-toast-outlet>
<div
  class="main-container center-wrapper"
  *ngIf="!isOnBatchRoute"
  [class.center-wrapper--full-height]="!showHeader"
>
  <app-welcome></app-welcome>
  <app-profile-selector></app-profile-selector>
</div>
<router-outlet />